import CLIENT from '../utils/restClient';
import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'UK_MTD_VAT_MODULE';
const log = new Logger('MAKING_TAX_DIGITAL_PAGE', LOG_LEVELS.DEBUG);
function namespaced(name) {
    return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_ACCESS_TOKEN = namespaced('LOAD_ACCESS_TOKEN');
const LOAD_ACCESS_TOKEN_OK = namespaced('LOAD_ACCESS_TOKEN_OK');
const LOAD_ACCESS_TOKEN_FAIL = namespaced('LOAD_ACCESS_TOKEN_FAIL');
const LOAD_LIABILITIES = namespaced('LOAD_LIABILITIES');
const LOAD_LIABILITIES_OK = namespaced('LOAD_LIABILITIES_OK');
const LOAD_LIABILITIES_FAIL = namespaced('LOAD_LIABILITIES_FAIL');
const LOAD_PAYMENTS = namespaced('LOAD_PAYMENTS');
const LOAD_PAYMENTS_OK = namespaced('LOAD_PAYMENTS_OK');
const LOAD_PAYMENTS_FAIL = namespaced('LOAD_PAYMENTS_FAIL');
const LOAD_OBLIGATIONS = namespaced('LOAD_OBLIGATIONS');
const LOAD_OBLIGATIONS_OK = namespaced('LOAD_OBLIGATIONS_OK');
const LOAD_OBLIGATIONS_FAIL = namespaced('LOAD_OBLIGATIONS_FAIL');
const LOAD_REPORT = namespaced('LOAD_REPORT');
const LOAD_REPORT_OK = namespaced('LOAD_REPORT_OK');
const LOAD_REPORT_FAIL = namespaced('LOAD_REPORT_FAIL');
// For now we are overloading the use of UPDATE to include delete too.
export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    LOAD_ACCESS_TOKEN,
    LOAD_ACCESS_TOKEN_OK,
    LOAD_ACCESS_TOKEN_FAIL,
    LOAD_LIABILITIES,
    LOAD_LIABILITIES_OK,
    LOAD_LIABILITIES_FAIL,
    LOAD_PAYMENTS,
    LOAD_PAYMENTS_OK,
    LOAD_PAYMENTS_FAIL,
    LOAD_OBLIGATIONS,
    LOAD_OBLIGATIONS_OK,
    LOAD_OBLIGATIONS_FAIL,
    LOAD_REPORT,
    LOAD_REPORT_OK,
    LOAD_REPORT_FAIL
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('actionHandler: ', action, state );
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_OK:
                return Object.assign({}, state, {Authorizationurl: action.response, loading: false, error: null});
            case LOAD_FAIL:
                return Object.assign({}, state, {data: undefined,Authorizationurl : undefined, loading: false, error: action.error});
            case LOAD_ACCESS_TOKEN:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_ACCESS_TOKEN_OK:
                return Object.assign({}, state, { loading: false, error: null});
            case LOAD_ACCESS_TOKEN_FAIL:
                return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
            case LOAD_LIABILITIES:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_LIABILITIES_OK:
                return Object.assign({}, state, {liabilities: action.response, loading: false, error: null});
            case LOAD_LIABILITIES_FAIL:
                return Object.assign({}, state, {liabilities : undefined, loading: false, error: action.error});
            case LOAD_PAYMENTS:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_PAYMENTS_OK:
                return Object.assign({}, state, {payments: action.response, loading: false, error: null});
            case LOAD_PAYMENTS_FAIL:
                return Object.assign({}, state, {data: undefined,payments : undefined, loading: false, error: action.error});
            case LOAD_OBLIGATIONS:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_OBLIGATIONS_OK:
                return Object.assign({}, state, {obligations: action.response, loading: false, error: null});
            case LOAD_OBLIGATIONS_FAIL:
                return Object.assign({}, state, {data: undefined,obligations : undefined, loading: false, error: action.error});
            case LOAD_REPORT:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_REPORT_OK:
                return Object.assign({}, state, {report: action.response, loading: false, error: null});
            case LOAD_REPORT_FAIL:
                return Object.assign({}, state, {data: undefined,report : undefined, loading: false, error: action.error});
            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('actionHandler:  newState', newState );
    return newState;
};

export const API = {
   doGetAuthorizationurl: () => {
       return (dispatch, getState) => {
           dispatch({type: LOAD});
           CLIENT.getUKMTDAuthorizationurl()
               .then((response) => {
                   log.debug('getUKMTDAuthorizationurl success' );

                   dispatch({type: LOAD_OK, response: response});
               })
               .catch((error) => {
                   log.debug('getUKMTDAuthorizationurl error' );

                   dispatch({type: LOAD_FAIL, error});
               });
       }
   },
    doUnauthenticateVATNumber: (vatnumber) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_ACCESS_TOKEN});
            CLIENT.unauthenticateVATNumber(vatnumber)
                .then((response) => {
                    log.debug('doUnauthenticateVATNumber success' );
                    dispatch({type: LOAD_ACCESS_TOKEN_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doUnauthenticateVATNumber error' );
                    dispatch({type: LOAD_ACCESS_TOKEN_FAIL, error});
                });
        }
    },

    doGetAccesstoken: (authorizationCode,vatnumber,companyCode,onSuccess,onFail) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_ACCESS_TOKEN});
            CLIENT.getUKMTDAccesstoken(authorizationCode,vatnumber,companyCode)
                .then((response) => {
                    log.debug('getUKMTDAccesstoken success' );
                    dispatch({type: LOAD_ACCESS_TOKEN_OK, response: response});
                    try {
                        if (onSuccess) onSuccess(response);
                    } catch (callbackError) {
                        log.warn('getUKMTDAccesstoken onSuccess callback failed', callbackError);
                    }
                })
                .catch((error) => {
                    log.debug('getUKMTDAccesstoken error' );
                    dispatch({type: LOAD_ACCESS_TOKEN_FAIL, error});
                    if (onFail) onFail(error);
                });
        }
    },
    doGetVATLiabilities: (params) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_LIABILITIES});
            CLIENT.getUKMTVATLiabilities(params)
                .then((response) => {
                    log.debug('doGetVATLiabilities success' );
                    log.clearDictionaryError(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH);
                    dispatch({type: LOAD_LIABILITIES_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doGetVATLiabilities error',error );
                    log.setDictionaryMessage(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH, error.message);
                    dispatch({type: LOAD_LIABILITIES_FAIL, error});
                });
        }
    },

    doGetVATPayments: (params) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_PAYMENTS});
            CLIENT.getUKMTVATPayments(params)
                .then((response) => {
                    log.debug('doGetVATPayments success' );
                    log.clearDictionaryError(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH);
                    dispatch({type: LOAD_PAYMENTS_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doGetVATPayments error' );
                    log.setDictionaryMessage(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH,error.message);
                    dispatch({type: LOAD_PAYMENTS_FAIL, error});
                });
        }
    },
    doGetObligations: (params) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_OBLIGATIONS});
            CLIENT.getUKMTObligations(params)
                .then((response) => {
                    log.debug('getUKMTObligations success' );
                    log.clearDictionaryError(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH);
                    dispatch({type: LOAD_OBLIGATIONS_OK, response: response});
                })
                .catch((error) => {
                    log.debug('getUKMTObligations error',error );
                    log.setDictionaryMessage(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH,error.message);
                    dispatch({type: LOAD_OBLIGATIONS_FAIL, error});
                });
        }
    },
    doGetReport: (params) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_REPORT});
            CLIENT.getUKMTVATReport(params)
                .then((response) => {
                    log.debug('getUKMTReport success' );
                    dispatch({type: LOAD_REPORT_OK, response: response});
                })
                .catch((error) => {
                    log.debug('getUKMTReport error',error );
                    log.setDictionaryMessage(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH,error.message);
                    dispatch({type: LOAD_REPORT_FAIL , error});
                });
        }
    },
};

export default API;

